import { CSSProperties } from 'react';
import { Platform, StyleSheet, TextInput, TextStyle, View, ViewStyle } from 'react-native';

interface DateInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  style?: ViewStyle;
  inputStyle?: TextStyle;
}

const webInputStyle: CSSProperties = {
  padding: '8px 12px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#d1d5db',
  borderRadius: '6px',
  fontSize: '14px',
  color: '#111827',
  backgroundColor: '#ffffff',
  width: '100%',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
};

const DateInput = ({
  value,
  onChange,
  placeholder = 'YYYY-MM-DD',
  style,
  inputStyle,
}: DateInputProps) => {
  if (Platform.OS === 'web') {
    return (
      <View style={style}>
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={webInputStyle}
        />
      </View>
    );
  }

  return (
    <TextInput
      style={[styles.nativeInput, inputStyle]}
      value={value}
      onChangeText={onChange}
      placeholder={placeholder}
      placeholderTextColor="#9ca3af"
    />
  );
};

const styles = StyleSheet.create({
  nativeInput: {
    borderWidth: 1,
    borderColor: '#d1d5db',
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    fontSize: 14,
    color: '#111827',
    backgroundColor: '#ffffff',
  },
});

export default DateInput;
